import $ from 'jquery';
import jqueryUjs from 'jquery-ujs';
import '../../assets/javascripts/polyfills/smoothscroll';

window.$ = $;
window.jQuery = $;

jqueryUjs($);
